import React from "react";
import useDistricts from "../../hooks/useDistricts";
import { activeDistrictNames } from "../../utils/districts";

/**
 * Sugestii pentru câmpurile „Sector" scrise de mână: sectoarele active din
 * Instrumente. Câmpul rămâne liber (valorile vechi nu se schimbă).
 */
export default function DistrictsDatalist({ id }) {
   const districts = useDistricts();
   return (
      <datalist id={id}>
         {activeDistrictNames(districts).map((name) => (
            <option key={name} value={name} />
         ))}
      </datalist>
   );
}
